module.exports = __webpack_public_path__ + "img/grid.9765502d.svg";